/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_NameInputs */



/**
* | output |
* | --- |
* | "File Name" |
*
* @param {File_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_name = /** @type {((inputs?: File_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateiname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имя файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイル名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do arquivo")
	return /** @type {LocalizedString} */ ("File Name")
});